export default __webpack_public_path__ + "static/media/RCNight4_14.37076848.jpg";